export default __webpack_public_path__ + "static/artc-1dee50f24c95049591e5fbc02b3f0eb0.png";